export enum LoginIntentENUM {
  LOGIN = 'LOGIN',
}
